import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy doctor page removed from the new site — permanently redirect to the doctors listing.
export const Route = createFileRoute("/doctors/dr-bruce-marko")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/doctors/", location.searchStr), statusCode: 301 });
  },
});
